let USER_OBJECT = {
   "email": "",
   "password": "",
   "firstName": "",
   "lastName": "",
   "country": "",
   "authenticated": false
};

export {USER_OBJECT};